import React, { useMemo, ReactNode, FC } from 'react';
import { useAccessControl } from './useAccessControl';

interface IHasAccess {
  role: string;
  children: ReactNode;
}

export const HasAccess: FC<IHasAccess> = React.memo(({ role, children, ...other }): any => {
  const { hasAccess } = useAccessControl();

  const showChildren = useMemo(() => {
    return hasAccess(role);
  }, [hasAccess, role]);

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, other);
    }
    return child;
  });

  return showChildren ? childrenWithProps : null;
});
